export const Props = () => ({
  //Всегда открыта вкладка?
  isAlwaysOpened: {
    type: Number,
    required: true,
  },

  //Режим отображения
  isFull: {
    type: Boolean,
    default: false,
  }
});